import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function CryptoLicenseWesternSahara (){

    return (
        <main className='main'>

            <IntroSection
                title="Crypto License – Western Sahara"
                subtitle="Launch Your Crypto Business with CRA Licensing"
                description =
                    "
                    The <b>Capital Regulatory Authority (CRA) of Western Sahara</b> offers one of the <b>most accessible and flexible crypto licensing frameworks</b> in the offshore market. With <b>no capital requirement</b> and <b>fast approvals</b>, CRA is the ideal choice for <b>exchanges, wallets, DeFi projects, tokenization, and blockchain startups</b> looking for a <b>cost-effective license</b>.
                    "
                badges={
                    [
                        "Crypto Exchange License",
                        "Wallet & Custodian License",
                        "VASP Registration",
                        "DLT License"
                    ]
                }
                buttonText="Request a Crypto License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/crypto-license-western-sahara-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Western Sahara?'
                        subtitle='Running a crypto business without a license limits your growth. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "No Capital Requirement",
                                            "text": "Unlike Malta, Estonia, or Gibraltar, there is no minimum capital requirement."
                                        },
                                        {
                                            "title": "Fast Approvals",
                                            "text": "License approvals are typically granted within 1–2 weeks."
                                        },
                                        {
                                            "title": "Operate Globally",
                                            "text": "Recognized in the offshore fintech and crypto community, allowing international operations."
                                        },
                                        {
                                            "title": "FATF-Aligned",
                                            "text": "CRA follows global AML/KYC guidelines to ensure compliance."
                                        },
                                        {
                                            "title": "Crypto-Friendly",
                                            "text": "Supports CEX, DEX, DeFi, tokenization, and NFT projects."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="What the License Covers"
                        subtitle='With a CRA Crypto License, your company can operate:'
                        item={
                            [
                                {
                                    "title": "Crypto Exchange (CEX & DEX)",
                                    "text": "Spot trading, swaps, and CFDs on digital assets."
                                },
                                {
                                    "title": "Custodian & Wallet Services",
                                    "text": "Hot and cold storage solutions for client funds."
                                },
                                {
                                    "title": "Virtual Asset Service Provider (VASP) Registration",
                                    "text": "FATF-compliant structure for VASP authorization."
                                },
                                {
                                    "title": "Token Issuance & ICO/IEO/STO",
                                    "text": "Legally launch token projects and raise capital."
                                },
                                {
                                    "title": "DeFi & NFT Platforms",
                                    "text": "Run decentralized apps and NFT marketplaces."
                                },
                                {
                                    "title": "Crypto Payment Services",
                                    "text": "Payment gateways for merchants accepting crypto."
                                }
                            ]
                        }
                    />


                    <InfoBlocks
                        title="Benefits of CRA Crypto License"
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "Global Market Entry",
                                            "text": "Provides legitimacy for banking and PSP onboarding."
                                        },
                                        {
                                            "title": "Banking Access",
                                            "text": "Open crypto-friendly EMI and PSP accounts."
                                        },
                                        {
                                            "title": "Compliance & Trust",
                                            "text": "AML/KYC compliance ensures credibility with partners."
                                        },
                                        {
                                            "title": "Scalability",
                                            "text": "Expand services such as wallets, exchanges, and tokenization under one license."
                                        },
                                        {
                                            "title": "Affordable Fees",
                                            "text": "Licensing fees are much lower than EU crypto regulators."
                                        }
                                    ]
                            }
                        ]}
                    />


                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                {
                                    "title": "Consultation & Planning",
                                    "text": "Define your business model (exchange, wallet, token, DeFi)."
                                },
                                {
                                    "title": "Company Incorporation",
                                    "text": "Register your entity under the CRA framework."
                                },
                                {
                                    "title": "Compliance Setup",
                                    "text": "Prepare AML/KYC manuals, risk policies, and business plan."
                                },
                                {
                                    "title": "Application Submission",
                                    "text": "Offshore Advisory submits the application with CRA."
                                },
                                {
                                    "title": "Approval & Activation",
                                    "text": "License granted and crypto operations commence."
                                }
                            ]
                        }
                        />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "1–2 weeks.",
                            },
                            {
                                name: "Setup Cost",
                                description: "Starting from USD 7,000+",
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "Competitive vs Malta/Estonia",
                            },
                            {
                                name: "Capital Requirement",
                                description: "None",
                            },
                        ]}
                        end='Costs vary by jurisdiction, license type, and compliance obligations.'
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { "text": "Experienced CRA agent specialized in crypto & fintech licensing." },
                                { "text": "End-to-end services: incorporation, compliance, licensing, and PSP setup." },
                                { "text": "Access to crypto-friendly PSPs & EMI accounts for banking and payment integration." },
                                { "text": "Technical integration support for CEX/DEX platforms, wallets, and custody solutions." },
                                { "text": "White-label exchange and wallet software available for rapid deployment." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Ready to launch your crypto business?
                             "
                         description=
                             "
                                With <b>no capital requirements</b> and <b>fast approvals</b>, <b>CRA (Western Sahara)</b> is one of the <b>most cost-effective crypto licensing jurisdictions worldwide</b>.
                             "
                         buttonText='Book a CRA Crypto License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is there a capital requirement for crypto licenses in Western Sahara?",
        content: [
            { type: "answer", text: "No — CRA has no minimum capital requirement, unlike Estonia or Malta." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "On average, 1–2 weeks, depending on documents." },
        ],
    },
    {
        question: "Can I run a DeFi or NFT project under this license?",
        content: [
            { type: "answer", text: "Yes — CRA allows flexible blockchain-based business models." },
        ],
    },
    {
        question: "Will this license help me open bank accounts?",
        content: [
            { type: "answer", text: "Yes — Offshore Advisory provides introductions to crypto-friendly EMI & PSP providers." },
        ],
    },
    {
        question: "Can I combine crypto with forex or gaming?",
        content: [
            { type: "answer", text: "Yes — CRA offers modular licensing, so you can expand into brokerage or iGaming under the same regulatory framework." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "We secured a CRA crypto license through Offshore Advisory in under 6 weeks. No capital requirement made it easy to launch our exchange.",
            author: "Alex M.",
            role: "Exchange Founder"
        },
        {
            quote: "Offshore Advisory helped us license a DeFi project in Western Sahara and integrate with crypto PSPs. Highly recommended.",
            author: "Sophia R.",
            role: "Blockchain Startup CEO"
        }
    ]
;